module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_dress@2x-4ce676f2a10556e546dee949e04d9755.webp";